import { createMenuCmdField, EntityManagerConfig } from '../models/entity-config';
import { DiplomiRoutes } from '../modules/diplomi/diplomi.app-manager-routes';

export class DiplomiEMC extends EntityManagerConfig {
  override initFields(): void {
    this.cmdFields = [
      createMenuCmdField(DiplomiRoutes.SearchCaniDiplomi),
      createMenuCmdField(DiplomiRoutes.StampaInviti)
    ];
  }
}
